// @constants
const actionTypes = require('constants/actionTypes');
const { COMMERCIAL_ADS_CHANNEL,FIRST_STEP } = require('constants/index');
// @actions
const signaturePatternActions = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');
// @utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLanguage } = require('core/i18n').i18n;

const resetState = () => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_RESET
});

const setAmount = (amount) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_SET_AMOUNT,
    payload: {
        amount
    }
});

const setAccount = (accountSelected) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_SET_ACCOUNT,
    payload: {
        accountSelected
    }
});

const setAccountAvailableBalance = (accountAvailableBalance) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_ACCOUNT_AVAILABLE_BALANCE,
    payload: {
        accountAvailableBalance
    }
});

function setAgreementCheckbox(checked) {
    return {
        type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_AGREEMENT_CHECKBOX,
        payload: {
            checked: checked
        }
    }
}

const setGiftVoucherAmount = (giftVoucherAmount) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_GIFT_VOUCHER_AMOUNT,
    payload: {
        giftVoucherAmount
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validateStep = (step) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_CARD_VALIDATE_STEP,
    payload: {
        step
    }
});

const getDestinationAccountRequest = () => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_GET_DESTINATION_ACCOUNT_REQUEST,
});

const getDestinationAccountSuccess = (response) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_GET_DESTINATION_ACCOUNT_SUCCESS,
    payload: {
        response
    }
});

const getDestinationAccountFailure = (error) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_GET_DESTINATION_ACCOUNT_FAILURE,
    payload: {
        error
    }
});

const setAmazonGiftCardRequest = () => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_GIFT_CARD_REQUEST,
});

const setAmazonGiftCardSuccess = (response) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_GIFT_CARD_SUCCESS,
    payload: {
        response
    }
});

const setAmazonGiftCardFailure = (error) => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_GIFT_CARD_FAILURE,
    payload: {
        error
    }
});

const amazonGiftCardImageIsFetching = () => ({
    type: actionTypes.AMAZON_GET_GIFT_CARD_IMAGE_IS_FETCHING,
})

const amazonGiftCardImageSuccess = (response) => ({
    type: actionTypes.AMAZON_GET_GIFT_CARD_IMAGE_SUCCESS,
    payload: {
        response
    }
});

const amazonGiftCardImageError = (error) => ({
    type: actionTypes.AMAZON_GET_GIFT_CARD_IMAGE_ERROR,
    payload: {
        error
    }
});

const setAmazonGiftCardPreContractCheckbox = checked => ({
    type: actionTypes.ACCOUNT_BUY_AMAZON_GIFT_SET_PRE_CONTRACT_CHECKBOX,
    payload: {
        checked
    }
});

const getDestinationAccount = () => (dispatch) => {
    dispatch(getDestinationAccountRequest());

    return APIGet({
        dispatch,
        endpoint: 'getDestinationAccount',
    })
        .then(response => {
            dispatch(getDestinationAccountSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getDestinationAccountFailure(response.error));
            } else {
                throw response;
            }
        });
};

const setAmazonGiftCard = (dispatch, data) => {
    const requestData = {
        query: data
    };

    dispatch(setAmazonGiftCardRequest());

    return APIPost({
        dispatch,
        endpoint: 'getAmazonGiftCard',
        params: requestData
    })
        .then(response => {
            dispatch(setAmazonGiftCardSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setAmazonGiftCardFailure(response.error));
            } else {
                throw response;
            }
        });
};

const getAmazonGiftCard = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const accountId = getState().accountsBuyAmazonGiftCard.getIn(['steps', FIRST_STEP, 'accountSelected']);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const email = PersonalDataHelper.getEmail(getState().profile);

        const data = {
            amount: getState().accountsBuyAmazonGiftCard.getIn(['steps', FIRST_STEP, 'amount']).toString(),
            contractNumber: immAccount.get('newContractNumber'),
            contratoOrdenanteIban: immAccount.get('iban'),
            producto: immAccount.get('newProduct'),
            holderFullName: immAccount.get('accountHolder'),
            emailId:email,
            dataToken
        };

        dispatch(updateConsents(dataToken))
            .then(() => setAmazonGiftCard(dispatch, data))
            .catch(response => {
                if (!!response.error) {
                    setAmazonGiftCard(dispatch, data);
                } else {
                    throw response;
                }
            });

    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const getAmazonGiftCardImage = (id) => (dispatch) => {
    dispatch(amazonGiftCardImageIsFetching());
    const params = {
        query: {
            channel: COMMERCIAL_ADS_CHANNEL,
            lang: getLanguage().toLowerCase(),
            locations: id
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'requestAds',
        params
    })
        .then(response => {
            dispatch(amazonGiftCardImageSuccess(response.nodes));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(amazonGiftCardImageError(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getAmazonGiftCard,
    getAmazonGiftCardImage,
    getDestinationAccount,
    resetState,
    setAccount,
    setAccountAvailableBalance,
    setAgreementCheckbox,
    setAmazonGiftCard,
    setAmazonGiftCardPreContractCheckbox,
    setAmount,
    setGiftVoucherAmount,
    setVisibleStep,
    setWillCancel,
    validateStep
};
